import clsx from "clsx";
import Image from "next/image";
import { getFormattedTextSpans } from "src/utils/textFormatting";
import balloonPic from "../../../../../public/images/balloon.png";
import { InterventionStep, InterventionStepMediaType } from "../../../../types/interventions";
import { ExternalLinkBox } from "../../ExternalLinkBoxes/ExternalLinkBox";
import { ExternalImageBox } from "../../ExternalLinkBoxes/ExternalImageBox";

type LimbicMessageProps = {
  step: InterventionStep;
  opaque?: boolean;
};

export const LimbicMessage = ({ step, opaque }: LimbicMessageProps) => (
  <div className={"mb-2.5 flex items-center"}>
    <div
      className={clsx(
        "relative flex h-[1.75rem] w-[1.75rem] flex-shrink-0 items-end justify-center rounded-full p-0.5  text-gray-800 transition-all duration-standard ease-in-out",
        opaque ? "bg-white/75" : "bg-gray-50",
      )}>
      <Image alt={"Limbic Bot Avatar"} src={balloonPic} height="80" width="80" />
    </div>
    <div
      data-id="container"
      className={clsx(
        "ml-2 inline-block min-h-[1.75rem] max-w-[25rem] flex-1 animate-intro-fade items-center gap-1 break-words rounded-2xl p-2 font-sans text-sm leading-tight text-gray-500 shadow-md",
        opaque ? "bg-white/75" : "",
      )}>
      {step.prompt &&
        getFormattedTextSpans(step.prompt).map((t, key) => (
          <span
            key={key}
            className={clsx(
              t.bold && "font-bold",
              t.italic && "italic",
              t.link && "text-blue-500 underline",
              t.underline && "underline",
            )}>
            {t.text}
          </span>
        ))}
      {step.mediaType === InterventionStepMediaType.image && step.mediaUrl && (
        <ExternalImageBox url={step.mediaUrl} title="Image" />
      )}
      {step.mediaType === InterventionStepMediaType.pdf && step.mediaUrl && (
        <ExternalLinkBox title="PDF File" url={step.mediaUrl} />
      )}
    </div>
  </div>
);
